export default __webpack_public_path__ + "static/media/camera group button.22a6af7e.svg";